export const STEP_WORK_TYPE = 'STEP_WORK_TYPE'
export const STEP_MACHINE = 'STEP_MACHINE'
export const STEP_SOFTWARE = 'STEP_SOFTWARE'
export const STEP_MONITOR = 'STEP_MONITOR'
export const STEP_KEYBOARD_MOUSE = 'STEP_KEYBOARD_MOUSE'
export const STEP_ACCESSORIES = 'STEP_ACCESSORIES'
export const STEP_ACCESSORIES_ALL = 'STEP_ACCESSORIES_ALL'
export const STEP_CONFIRM = 'STEP_CONFIRM'
export const STEP_SUMMARY = 'STEP_SUMMARY'
